export default () => {
    Alpine.store('breakpoint', {
        smMax: '(max-width: 639px)',
        sm: '(min-width: 640px)',
        mdMax: '(max-width: 767px)',
        md: '(min-width: 768px)',
        lgMax: '(max-width: 1023px)',
        lg: '(min-width: 1024px)',
        xl: '(min-width: 1280px)',
        '2xl': '(min-width: 1536px)',
        '3xl': '(min-width: 1680px)',
    })

    Alpine.store('animationDelay', 0.2)
    Alpine.store('enterDelay', 1.3)

    Alpine.store('avalanche', {
        ...Alpine.store('avalanche'),
        delay: {
            default: Alpine.store('animationDelay'),
            enter: Alpine.store('enterDelay'),
        },
    })

    Alpine.store('focusState', false)
    Alpine.store('alertBar', {
        active: false,
        height: 0,
    })

    Alpine.store('header', {
        height: 0,
    })

    Alpine.store('nav', {
        open: false,
        dropdown: true,
        animating: false,
        activeItem: null,
        closeItem: null,
        ministry: false,
        ministryClose: false,

        toggle() {
            if (this.open) {
                document.body.classList.remove('no-scroll')
            } else {
                document.body.classList.add('no-scroll')
            }

            const timeout = this.dropdownReset()

            setTimeout(() => {
                this.open = !this.open
            }, timeout)
        },

        dropdownReset() {
            let timeout = 0
            if (this.dropdown) {
                this.dropdown = false
                timeout = 200
            }

            return timeout
        },

        close() {
            this.dropdown = false
            this.animating = false
            const timeout = this.dropdownReset()

            setTimeout(() => {
                this.open = false
                this.activeItem = null
                this.closeItem = null
            }, timeout)
        },
    })

    Alpine.store('search', {
        open: false,

        toggle() {
            this.open = !this.open
        },

        close() {
            if (this.open) {
                this.open = false
            }
        },
    })

    Alpine.store('showModal', {
        open: false,
    })

    Alpine.store('lightboxCards', {
        open: false,
        animating: false,
        headline: null,
        cards: [],

        toggle() {
            if (!this.animating) {
                this.animating = true
                this.open = !this.open
            }
        },
    })

    Alpine.store('lightboxForm', {
        open: false,
        animating: false,
        toggle() {
            if (!this.animating) {
                this.animating = true
                this.open = !this.open
            }
        },
    })

    document.addEventListener('visibilitychange', () => {
        Alpine.store('audioPause', document.hidden)
    })

    Alpine.store('lightboxVideo', {
        open: false,
        source: '',
        videoID: '',
        mp4: '',
        webm: '',
        poster: '',
        ratio: '16:9',
    })

    Alpine.store('audioMute', false) // User Toggled & Persisted
    Alpine.store('audioPause', false)
}
